import { Button } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";

import { messages as extensionsMessages } from "../messages";

export const RequestExtensionsButton = () => {
  const intl = useIntl();

  return (
    <Button variant="secondary" target="_blank" onClick={() => alert("Nice try Bob!")}>
      {intl.formatMessage(extensionsMessages.missingExtensionsButton)}
    </Button>
  );
};
